<template>
  <!-- <layouts-instructorborder></layouts-instructorborder> -->
  <div class="course-layout-wrapper">
    <course-layout-breadcrumb :title="course?.title" :student="studentName" />
    
    <!-- Mobile Menu Toggle Button -->
    <button class="mobile-menu-toggle" @click="toggleSidebar">
      <i class="fa fa-bars"></i>
    </button>

    <!-- Page Content -->
    <div class="page-content" style="background: #fafafa;
    padding: 0px; border: 1px solid #d1d7dc;">
      <div class="container" style="max-width: 100%;">
        <div class="row">

          <!-- sidebar -->
          <div class="col-xl-3 col-lg-3 theiaStickySidebar">
            <div class="stickysidebar">
              <Loading v-model:active="loadingStore.isLoading" :can-cancel="false" :is-full-page="true" />
              
              <aside class="course-sidebar" :class="{ 'mobile-open': sidebarOpen }">
                <div class="sidebar-header">
                  <div class="row">
                    <div class="col-12">
                      </div>
                    <div class="logos" v-if="course" style="padding: 1rem 1.5rem; text-align: center; border-bottom: 1px solid #d1d7dc;">
                      <img src="@/assets/img/caduceus.png" alt="LMS Logo" style="max-width: 150px; margin-bottom: 1rem;">
                      <router-link to="/caduceus/dashboard" class="btn btn-enroll w-100" style="display: block; padding: 0.5rem 1rem; text-align: center;">Meus Cursos</router-link>
                    </div>

                  </div>
                  <!-- <div class="row">
                    <div class="col-12">
                      <h3>Conteúdo do Curso</h3>
                  <button class="close-sidebar" @click="toggleSidebar">
                    <i class="fa fa-times"></i>
                  </button>

                    </div>

                  </div> -->

                </div>

                <div class="sidebar-content">
                  
                  <!-- Course Modules -->
                  <div class="modules-list">
                    <template v-for="(module, moduleIndex) in course?.modules" :key="module.id">
                      <div class="module-section">
                        <button class="module-header" @click="toggleModule(moduleIndex)">
                          <div class="module-title-wrapper">
                            <i class="fas fa-chevron-down module-chevron" :class="{ 'expanded': expandedModules[moduleIndex] }"></i>
                            <span class="module-title">{{ module.title }}</span>
                          </div>
                          <span class="module-lesson-count">{{ getEnabledLessonsCount(module) }}</span>
                        </button>

                        <transition name="expand">
                          <div class="lessons-container" v-show="expandedModules[moduleIndex]">
                            <template v-for="(lesson, lessonIndex) in module.lessons" :key="lesson.id">
                              <button
                                v-if="lesson.isEnabled"
                                class="lesson-button"
                                :class="{ 'active': currentLesson.id === lesson.id }"
                                @click="selectLesson(module, lesson)"
                              >
                                <div class="lesson-checkbox">
                                  <i class="fas fa-check-circle" v-if="currentLesson.id === lesson.id"></i>
                                  <i class="far fa-circle" v-else></i>
                                </div>
                                <div class="lesson-content">
                                  <div class="lesson-title-row">
                                    <span class="lesson-title">{{ lesson.title }}</span>
                                  </div>
                                  <div class="lesson-meta">
                                    <i class="fas fa-play-circle" v-if="lesson.contentType === 'YOUTUBE' || lesson.contentType === 'PANDA'"></i>
                                    <i class="fas fa-file-pdf" v-if="lesson.contentType === 'PDF'"></i>
                                    <i class="fas fa-question-circle" v-if="lesson.contentType === 'QUIZ'"></i>
                                    <span class="lesson-type">{{ getLessonType(lesson.contentType) }}</span>
                                  </div>
                                </div>
                              </button>
                            </template>
                          </div>
                        </transition>
                      </div>
                    </template>

                    <!-- Certificate Section -->
                    <div class="module-section certificate-module" v-if="isCertificateAvailable && !isPreview">
                      <button class="module-header certificate-header" @click="selectCertificate()">
                        <div class="module-title-wrapper">
                          <i class="fas fa-trophy certificate-icon"></i>
                          <span class="module-title">Certificado</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
          <!-- /Sidebar -->

          <!-- Student Dashboard -->
          <div class="col-xl-9 col-lg-9">


            <!-- /Dashboard Grid -->



            <div class="dashboard-title" style="padding: 1rem 1.5rem; ">
              <h4>{{ currentLesson.title }}</h4>
            </div>
            <div class="row">

              <!-- Course Grid -->
              <div class="col-xxl-12 col-md-12 d-flex">
                <div class="course-box flex-fill">
                  <!-- Blocked Lesson Message -->
                  <div v-if="selectedContent === 'blocked'" class="lesson-blocked-container">
                    <div class="blocked-message">
                      <div class="blocked-icon">
                        <i class="fas fa-lock"></i>
                      </div>
                      <h3>Conteúdo Bloqueado</h3>
                      <p class="blocked-reason">{{ lessonBlockedInfo?.blockedReason || 'Esta aula está bloqueada.' }}</p>
                      <p class="blocked-instruction" v-if="lessonBlockedInfo?.requiredQuizLessonTitle">
                        Complete o quiz "<strong>{{ lessonBlockedInfo.requiredQuizLessonTitle }}</strong>" para desbloquear este conteúdo.
                      </p>
                    </div>
                  </div>

                  <div v-show="selectedContent === 'lesson'" class="video-wrapper">
                    <!-- Quiz Component -->
                    <div v-if="currentLesson.contentType === 'QUIZ'">
                      <QuizPlayer
                        :lesson="currentLesson"
                        :course-id="course.id"
                        @quiz-completed="handleQuizCompleted"
                      />
                    </div>
                    <!-- Video/PDF Content -->
                    <div v-else>
                      <div class="video-player" v-if="currentLesson.contentType !== 'PANDA'">
                        <LiteYouTubeEmbed v-if="currentLesson.contentType === 'YOUTUBE'"
                          :id="currentLesson.contentUrl.split('=')[1]" class="video-embed" title="Vídeo da Lição" />
                          <embed v-if="currentLesson.contentType === 'PDF'" :src="'https://docs.google.com/gview?embedded=true&url=' + currentLesson.contentUrl" type="application/pdf" width="100%" height="600px" />

                        <!-- <iframe v-if="currentLesson.contentType === 'PDF'" :src="currentLesson.contentUrl" frameborder="0"></iframe>
                          <a :href="currentLesson.contentUrl" download v-if="currentLesson.contentUrl">Baixar</a> -->

                      </div>
                      <div class="video-player" v-if="currentLesson.contentType === 'PANDA'">
                        <iframe id="panda-c8e74019-dd82-4cf1-a3f6-9a85a7a61244" :src="currentPandaVideo.contentUrl" style="border:none;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture" allowfullscreen=true width="100%" height="600px" fetchpriority="high"></iframe>


                      </div>
                    </div>
                  </div>
                  <!-- 🔹 Área do certificado -->
                  <div v-if="selectedContent === 'certificate'" class="certificate-container">
                    <iframe v-if="certificateUrl" :src="certificateUrl" frameborder="0"></iframe>
                    <a :href="certificateUrl" download v-if="certificateUrl">Baixar Certificado</a>
                  </div>

                  <!-- <div class="product">
                  <div class="product-content">
                  </div>
                </div> -->
                </div>
              </div>
              <!-- /Course Grid -->

              <!-- Course Grid -->
              <!-- <div class="col-xxl-4 col-md-6 d-flex">
                          <div class="course-box flex-fill">
                              <div class="product">
                                  <div class="product-img">
                                      <router-link to="/course/course-details">
                                          <img class="img-fluid" alt="Img" src="@/assets/img/course/course-03.jpg">
                                      </router-link>
                                      <div class="price combo">
                                          <h3>FREE</h3>
                                      </div>
                                  </div>
                                  <div class="product-content">
                                      <div class="course-group d-flex">
                                          <div class="course-group-img d-flex">
                                              <router-link to="/instructor/instructor-profile"><img src="@/assets/img/user/user5.jpg"
                                                      alt="Img" class="img-fluid"></router-link>
                                              <div class="course-name">
                                                  <h4><router-link to="/instructor/instructor-profile">Jenny</router-link></h4>
                                                  <p>Instructor</p>
                                              </div>
                                          </div>
                                          <div class="course-share d-flex align-items-center justify-content-center">
                                              <a href="#"><i class="fa-regular fa-heart"></i></a>
                                          </div>
                                      </div>
                                      <h3 class="title instructor-text"><router-link to="/course/course-details">Sketch from A to
                                              Z (2022): Become an app designer</router-link></h3>
                                      <div class="course-info d-flex align-items-center">
                                          <div class="rating-img d-flex align-items-center">
                                              <img src="@/assets/img/icon/icon-01.svg" alt="Img">
                                              <p>10+ Lesson</p>
                                          </div>
                                          <div class="course-view d-flex align-items-center">
                                              <img src="@/assets/img/icon/icon-02.svg" alt="Img">
                                              <p>40hr 10min</p>
                                          </div>
                                      </div>
                                      <div class="rating mb-0">
                                          <i class="fas fa-star filled me-1"></i>
                                          <i class="fas fa-star filled me-1"></i>
                                          <i class="fas fa-star filled me-1"></i>
                                          <i class="fas fa-star me-1"></i>
                                          <i class="fas fa-star me-1"></i>
                                          <span class="d-inline-block average-rating"><span>3.0</span> (18)</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div> -->
              <!-- /Course Grid -->


            </div>
            <!-- <div class="dash-pagination">
                      <div class="row align-items-center">
                          <div class="col-6">
                              <p>Page 1 of 2</p>
                          </div>
                          <div class="col-6">
                              <ul class="pagination">
                                  <li class="active">
                                      <a href="#">1</a>
                                  </li>
                                  <li>
                                      <a href="#">2</a>
                                  </li>
                                  <li>
                                      <a href="#"><i class="bx bx-chevron-right"></i></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div> -->
          </div>
          <!-- Student Dashboard -->

        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Overlay for mobile sidebar -->
    <div class="sidebar-overlay" :class="{ 'active': sidebarOpen }" @click="toggleSidebar"></div>
  </div>
  <!-- <layouts1></layouts1> -->
</template>


<script setup>
import ApiService from '@/services/ApiService';
import axiosInstance, { tratarError } from '@/axiosConfig';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import { storeToRefs } from 'pinia';
import { useLoadinStore } from '@/stores/loadingStore';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { BCard, BDropdown, BDropdownItem } from 'bootstrap-vue-3';
import QuizPlayer from '@/components/quiz/QuizPlayer.vue';
import { JWTHandler } from '@/jwtHandler';
const loadingStore = storeToRefs(useLoadinStore());
const title = ref('title')
const text = ref('text')
const text1 = ref('text1')
// Dados simulados para exemplo
const studentName = ref('');
const courseTitle = 'Curso de Vue.js';
const route = useRoute();
const slug = route.params.slug; // slug do enrollment (modo normal)
const courseId = route.params.id; // ID do curso (modo preview)
const isPreview = !!courseId; // Detecta se está em modo preview
const course = ref();
const isCertificateAvailable = ref(false);
onMounted(async () => {

  // Carregar dados do curso e do aluno
  try {
    let response;
    if (isPreview) {
      // Modo preview: usar endpoint de preview
      response = await ApiService.get(`/courses/${courseId}/preview`);
      course.value = response.data.course;
      studentName.value = response.data.student || JWTHandler.getUserData()?.fullName || 'Preview';
      isCertificateAvailable.value = false; // Certificado não disponível em preview
    } else {
      // Modo normal: usar endpoint de enrollment
      response = await ApiService.get(`/enrollments/${slug}/course`);
      course.value = response.data.course;
      studentName.value = response.data.student;
      isCertificateAvailable.value = response.data.isCertificateAvailable;
    }
    
    if (course.value && course.value.modules && course.value.modules.length > 0 && 
        course.value.modules[0].lessons && course.value.modules[0].lessons.length > 0) {
      expandedModules.value[0] = true;
      selectLesson(course.value.modules[0], course.value.modules[0].lessons[0]);
    }


    if (!window.YT) {
      const scriptTag = document.createElement('script');
      scriptTag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(scriptTag);
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    } else {
      initializePlayer(); // Caso o script já esteja carregado
    }
  } catch (error) {
    tratarError(error);
    console.error('Erro no pagamento:', error);
  }
  // studentName.value = response.data.user.firstName;

});
// const modules = ref([
//   { id: 1, title: 'Módulo 1', lessons: [
//       { id: 101, title: 'Lição 1.1', contentType: 'VIDEO', contentUrl: 'https://path.to/video1' },
//       { id: 102, title: 'Lição 1.2', contentType: 'VIDEO', contentUrl: 'https://path.to/video2' }
//     ]},
//   { id: 2, title: 'Módulo 2', lessons: [
//       { id: 201, title: 'Lição 2.1', contentType: 'PDF', contentUrl: 'https://path.to/doc1.pdf' },
//       { id: 202, title: 'Lição 2.2', contentType: 'VIDEO', contentUrl: 'https://path.to/video3' }
//     ]}
// ]);

// Estado reativo para a lição selecionada
const currentLesson = ref({});
const currentModule = ref({});
const selectedContent = ref("lesson");
const certificateUrl = ref();
const currentPandaVideo = ref({});
const sidebarOpen = ref(false);
const expandedModules = ref({});
const lessonBlockedInfo = ref(null); // Stores blocking information for current lesson attempt

const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
};

const toggleModule = (index) => {
  expandedModules.value[index] = !expandedModules.value[index];
};

const getEnabledLessonsCount = (module) => {
  const count = module.lessons?.filter(l => l.isEnabled).length || 0;
  return count === 1 ? '1 aula' : `${count} aulas`;
};

const getLessonType = (contentType) => {
  const types = {
    'YOUTUBE': 'Vídeo',
    'PANDA': 'Vídeo',
    'PDF': 'Documento',
    'QUIZ': 'Quiz'
  };
  return types[contentType] || 'Conteúdo';
};

const selectLesson = async (module, lesson) => {
  currentLesson.value = lesson;
  currentModule.value = module;
  selectedContent.value = 'lesson';
  showPlayer.value = true;

  if (window.innerWidth < 992) {
    sidebarOpen.value = false;
  }

  // Check lesson access for non-preview mode
  if (!isPreview && (lesson.contentType === 'YOUTUBE' || lesson.contentType === 'PDF' || lesson.contentType === 'QUIZ')) {
    const accessInfo = await checkLessonAccess(lesson);

    if (accessInfo.isBlocked) {
      lessonBlockedInfo.value = accessInfo;
      selectedContent.value = 'blocked';
      showPlayer.value = false;
      return;
    }

    lessonBlockedInfo.value = null;
  }

  if (currentLesson.value.contentType === 'YOUTUBE') {
    if (player) {
      // player.loadVideoById(currentLesson.value.contentUrl.split('=')[1]);
    }
  } else if (currentLesson.value.contentType === 'PANDA') {
    await loadPandaVideo(currentLesson.value);
  } else if (currentLesson.value.contentType === 'QUIZ') {
    // Quiz will be handled by QuizPlayer component
    showPlayer.value = false;
  }
};

const handleQuizCompleted = () => {
  // Handle quiz completion - could navigate to next lesson or show success message
  console.log('Quiz completed');
};

const checkLessonAccess = async (lesson) => {
  if (isPreview && lesson.contentType !== 'PANDA') {
    return {
      isBlocked: false,
      contentUrl: lesson.contentUrl,
    };
  }

  try {
    const response = await ApiService.get(`/lessons/${lesson.id}/panda`);
    return {
      isBlocked: response.data.isBlocked || false,
      blockedReason: response.data.blockedReason,
      requiredQuizLessonTitle: response.data.requiredQuizLessonTitle,
      contentUrl: response.data.contentUrl // For PANDA videos
    };
  } catch (error) {
    tratarError(error);
    console.error('Erro ao verificar acesso à lição:', error);
    return { isBlocked: false };
  }
};

const loadPandaVideo = async (lesson) => {
  showPlayer.value = false;
  currentPandaVideo.value = {};
  const accessInfo = await checkLessonAccess(lesson);

  if (accessInfo.isBlocked) {
    lessonBlockedInfo.value = accessInfo;
    selectedContent.value = 'blocked';
    return;
  }

  lessonBlockedInfo.value = null;
  currentPandaVideo.value = { contentUrl: accessInfo.contentUrl };
  selectedContent.value = 'lesson';
};

const selectCertificate = async () => {
  if (isPreview) {
    // Certificado não disponível em modo preview
    return;
  }
  showPlayer.value = false;
  try {
    const response = await ApiService.get(`/enrollments/certificate/${slug}`);
    certificateUrl.value = response.data;
  } catch (error) {
    tratarError(error);
    console.error('Erro no pagamento:', error);
  }
  selectedContent.value = 'certificate';

  if (window.innerWidth < 992) {
    sidebarOpen.value = false;
  }
};

const showPlayer = ref(true); // Controla o v-if

let player;
let updateInterval;
const watchedTime = ref(0);
function initializePlayer() {
  // Verifica se a API está disponível
  if (window.YT && window.YT.Player) {
    player = new YT.Player('player', {
      height: '360',
      width: '640',
      videoId: 'dQw4w9WgXcQ', // Video inicial
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  }
}
// Função a ser chamada quando a API estiver pronta
function onYouTubeIframeAPIReady() {
  console.log('YouTube API Ready');
  initializePlayer();
}

// Função chamada quando o player está pronto
function onPlayerReady(event) {
  console.log('Player is readys');
  event.target.playVideo();
}

// Manipulador para mudanças no estado do player

function onPlayerStateChange(event) {
  if (event.data === YT.PlayerState.PLAYING) {
    updateInterval = setInterval(() => {
      watchedTime.value = Math.floor(player.getCurrentTime());
    }, 1000);
  } else {
    clearInterval(updateInterval);
  }
}
// Reconstrua o player sempre que showPlayer mudar para true
watch(showPlayer, (newValue) => {
  if (newValue) {
    initializePlayer();
  } else {
    clearInterval(updateInterval);
  }
});
function togglePlayer() {
  showPlayer.value = !showPlayer.value;
}
onBeforeUnmount(() => {
  clearInterval(updateInterval);
});
</script>

<style>
.nav-item:hover {
  color: #129f46;
  font-weight: bold;
  cursor: pointer;
}

.active {
  color: #129f46;
}

.certificate-container {
  padding: 20px;
  background-color: #f9f9f9;
  text-align: center;
}

.certificate-container iframe {
  border: none;
  width: 100%;
  min-height: fit-content;
  min-height: 600px;
}

.logos {
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

.logos img {
  max-width: 100%;
  height: auto;
}

/* Sidebar Styles from v3 */
.course-sidebar {
  width: 100%;
  background-color: #f7f9fa;
  border-right: 1px solid #d1d7dc;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100vh - 120px);
}

.sidebar-header {
  padding: 1rem 1.5rem;
  background-color: #fff;
  /* border-bottom: 1px solid #d1d7dc; */
  /* display: flex; */
  /* justify-content: space-between; */
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
}

.sidebar-header h3 {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
  color: #1c1d1f;
}

.close-sidebar {
  display: none;
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  color: #1c1d1f;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-sidebar:hover {
  background-color: #e3e7ea;
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.modules-list {
  padding: 0;
}

.module-section {
  background-color: #fff;
  border-bottom: 1px solid #d1d7dc;
}

.module-header {
  width: 100%;
  padding: 1rem 1.5rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.15s;
  text-align: left;
}

.module-header:hover {
  background-color: #f7f9fa;
}

.module-title-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
}

.module-chevron {
  font-size: 0.75rem;
  color: #1c1d1f;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.module-chevron.expanded {
  transform: rotate(-180deg);
}

.module-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1c1d1f;
  line-height: 1.4;
}

.module-lesson-count {
  font-size: 0.875rem;
  color: #6a6f73;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.lessons-container {
  background-color: #f7f9fa;
  padding: 0.5rem 0;
}

.lesson-button {
  width: 100%;
  padding: 0.75rem 1.5rem 0.75rem 3rem;
  background-color: transparent;
  border: none;
  border-left: 4px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  text-align: left;
  transition: all 0.15s;
}

.lesson-button:hover {
  background-color: #e3e7ea;
}

.lesson-button.active {
  background-color: #d1e7dd;
  border-left-color: #0d6efd;
}

.lesson-checkbox {
  flex-shrink: 0;
  font-size: 1rem;
  color: #6a6f73;
  margin-top: 0.125rem;
}

.lesson-button.active .lesson-checkbox {
  color: #0d6efd;
}

.lesson-checkbox i {
  display: block;
}

.lesson-content {
  flex: 1;
  min-width: 0;
}

.lesson-title-row {
  margin-bottom: 0.25rem;
}

.lesson-title {
  font-size: 0.875rem;
  font-weight: 400;
  color: #1c1d1f;
  line-height: 1.4;
  display: block;
}

.lesson-button.active .lesson-title {
  font-weight: 600;
  color: #1c1d1f;
}

.lesson-meta {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.25rem;
}

.lesson-meta i {
  font-size: 0.75rem;
  color: #6a6f73;
}

.lesson-type {
  font-size: 0.75rem;
  color: #6a6f73;
}

.certificate-module {
  background-color: #fff;
}

.certificate-header {
  background-color: #fef5e7;
}

.certificate-header:hover {
  background-color: #fdebd0;
}

.certificate-icon {
  color: #f39c12;
  font-size: 1rem;
}

/* Transitions */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  max-height: 2000px;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Responsive Design */
@media (max-width: 991px) {
  .course-sidebar {
    position: fixed;
    top: 0;
    left: -380px;
    width: 380px;
    height: 100vh;
    z-index: 1000;
    transition: left 0.3s ease;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  }

  .course-sidebar.mobile-open {
    left: 0;
  }

  .close-sidebar {
    display: block;
  }
}

@media (max-width: 767px) {
  .course-sidebar {
    width: 85%;
    left: -85%;
  }
}

.mobile-menu-toggle {
  position: fixed;
  top: 100px;
  left: 1rem;
  z-index: 999;
  background: #129f46;
  color: #fff;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;
  display: none;
}

.mobile-menu-toggle:hover {
  background: #0d7d35;
}

@media (max-width: 991px) {
  .mobile-menu-toggle {
    display: block;
  }
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  transition: opacity 0.3s;
}

.sidebar-overlay.active {
  opacity: 1;
}

@media (max-width: 991px) {
  .sidebar-overlay {
    display: block;
  }
}

/* Blocked Lesson Styles */
.lesson-blocked-container {
  padding: 60px 40px;
  background-color: #fff;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blocked-message {
  text-align: center;
  max-width: 500px;
}

.blocked-icon {
  font-size: 72px;
  color: #f39c12;
  margin-bottom: 20px;
}

.blocked-message h3 {
  font-size: 24px;
  font-weight: 700;
  color: #1c1d1f;
  margin-bottom: 15px;
}

.blocked-reason {
  font-size: 16px;
  color: #6a6f73;
  margin-bottom: 10px;
  line-height: 1.5;
}

.blocked-instruction {
  font-size: 16px;
  color: #1c1d1f;
  padding: 15px 20px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  margin-top: 20px;
  line-height: 1.6;
}

.blocked-instruction strong {
  color: #129f46;
  font-weight: 600;
}
</style>
